import styled from 'styled-components';
import { Drawer } from 'antd';

export const StyledMotherDrawer = styled(Drawer)`
  .ant-drawer-header {
    min-height: 113px;

    .ant-drawer-header-title {
      display: flex;
      flex-direction: row-reverse;
    }

    .ant-drawer-close {
      color: ${({ theme }) => theme.black};
    }
  }

  .custom-header {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .header-top {
      display: flex;
      align-items: center;
      gap: 10px;

      .transaction-type {
        font-size: 18px;
        font-weight: 600;
        color: ${({ theme }) => theme.contractTextTitleColor};
      }

      .status-tag.ant-tag {
        background-color: ${({ theme }) => theme.darkGrayishBlue} !important;
        color: ${({ theme }) => theme.white} !important;
        border-radius: 14px;
        padding: 1px 10px;
        border: none;
        font-weight: 400;
      }
    }

    .transaction-nr {
      font-size: 14px;
      color: ${({ theme }) => theme.colorPadding};
    }
  }
`;

export const StyledChildList = styled.div`
  .no-children {
    color: ${({ theme }) => theme.colorPadding};
    font-size: 14px;
  }
`;

export const StyledChildRow = styled.div`
  display: grid;
  grid-template-columns: auto auto auto 1fr;
  align-items: center;
  gap: 8px 12px;
  padding: 16px;
  margin-bottom: 12px;
  background-color: ${({ theme }) => theme.categoryContentBackground};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.border};

  .child-invoice {
    font-weight: 600;
    color: ${({ theme }) => theme.contractTextTitleColor};
  }

  .child-amount {
    font-weight: 600;
    color: ${({ theme }) => theme.contractTextTitleColor};
  }

  .child-farm {
    color: ${({ theme }) => theme.black};
  }

  .child-status-tag.ant-tag {
    border-radius: 14px;
    padding: 1px 10px;
    border: none;
    font-weight: 400;
    margin-inline-end: 0;
    color: ${({ theme }) => theme.white} !important;
    background-color: ${({ theme }) => theme.motherChildStatusNew} !important;

    &.status-done {
      background-color: ${({ theme }) =>
        theme.motherChildStatusDone} !important;
    }
    &.status-sent {
      background-color: ${({ theme }) =>
        theme.motherChildStatusSent} !important;
    }
    &.status-confirmed {
      background-color: ${({ theme }) =>
        theme.motherChildStatusConfirmed} !important;
    }
    &.status-partially_sent {
      background-color: ${({ theme }) =>
        theme.motherChildStatusPartiallySent} !important;
    }
    &.status-canceled,
    &.status-cancelled {
      background-color: ${({ theme }) =>
        theme.motherChildStatusCanceled} !important;
    }
    &.status-new {
      background-color: ${({ theme }) => theme.motherChildStatusNew} !important;
    }
    &.status-pending_send {
      background-color: ${({ theme }) =>
        theme.motherChildStatusPendingSend} !important;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr auto;

    .child-invoice {
      grid-column: 1;
      grid-row: 1;
    }

    .child-status-tag {
      grid-column: 2;
      grid-row: 1;
      justify-self: end;
    }

    .child-farm {
      grid-column: 1;
      grid-row: 2;
    }

    .child-amount {
      grid-column: 2;
      grid-row: 2;
      justify-self: end;
    }
  }
`;

export const StyledChildActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  grid-column: 1 / -1;

  .ant-btn {
    background: transparent;
    border: 1px solid ${({ theme }) => theme.darkGrayishBlue};
    color: ${({ theme }) => theme.darkGrayishBlue};
    border-radius: 4px;

    &:hover {
      border-color: ${({ theme }) => theme.darkGrayishBlue};
      color: ${({ theme }) => theme.darkGrayishBlue};
      opacity: 0.8;
    }
  }

  @media (max-width: 768px) {
    grid-column: 1 / -1;
    justify-self: end;
  }
`;

export const StyledMotherDrawerFooter = styled.div`
  display: flex;
  justify-content: flex-end;

  .ant-btn {
    background: transparent;
    border: 1px solid ${({ theme }) => theme.darkGrayishBlue};
    color: ${({ theme }) => theme.darkGrayishBlue};
    border-radius: 4px;

    &:hover {
      border-color: ${({ theme }) => theme.darkGrayishBlue};
      color: ${({ theme }) => theme.darkGrayishBlue};
      opacity: 0.8;
    }
  }
`;
